<template>
  <div class="page flex column">
    <app-header class="flex0" :title="title">
      <i slot="back"></i>
    </app-header>
    <div class="doctorInfo flex0">
      <ul>
        <li>
          <div class="cancelImg">
            <img :src="doctorInfo.docAvatar?doctorInfo.docAvatar:'./static/img/doctor.m.png'" alt="" class="radius50"
                 @error="__docError">
          </div>
          <div class="cancelIntro">
            <div class="introTitle">
              <span class="subTitle">{{ doctorInfo.docName }}</span>
              <span class="myDoctor"><span
                v-html="renderDocTitleHtml(doctorInfo)"></span></span>
              <p>{{ doctorInfo.docHosName }}</p>
              <p>{{ doctorInfo.docDeptName }}</p>
            </div>
          </div>
          <div class="in_free_clinic" v-if="inFreeClinic">义诊中</div>
        </li>
      </ul>
    </div>
    <div class="attach flex0">
      <div>
        <section>
          <span>图文咨询价格</span>
          <span class="money">价格：¥ {{ showPrice }}{{ showLimit }}</span>
        </section>
      </div>
    </div>
    <!--<div class=" weui-cells_checkbox weuiMargin">
      <label class="weui-cell weui-check__label" for="s11">
        <div class="weui-cell__hd">
          <input type="checkbox" class="weui-check" name="checkbox1" id="s11" checked="checked"
                 v-model="picked"/>
          <i class="weui-icon-checked color_main"></i>
        </div>
        <div class="weui-cell__bd">
          <p>我已阅读并同意
            <router-link tag="span" to="/internetTerms">浙二网络医学中心服务协议</router-link>
          </p>
        </div>
      </label>
    </div>-->
    <div class="applyRule pb30 flex1 overflow-y-auto">
      <div class="ruleCenter">
        <h4>图文问诊规则</h4>
        <p class="color_999">1、您需要填写自己的就诊资料，并付费；</p>
        <p class="color_999">2、若医生没有在24小时内回复您，我们会为您自动退款；</p>
        <template v-if="limit>0">
          <p class="color_999">3、您最多可以回复 <span class="color_main">{{ limit }}条，</span>
            <span class="color_main">请尽量将您的问题、希望获得的帮助一次性完整提出；</span></p>
        </template>
        <template v-else>
          <p class="color_999">3、医生第一次回复您之后，您可以在48小时内继续追问；</p>
        </template>
        <p class="color_red">4、咨询将会在48小时后自动结束，请尽快提问；</p>
        <p class="color_red">
          5、各位患者：如果您当前就诊需求三个月内未曾在我院相关科室进行就诊，此为线上咨询服务，内容仅供参考</p>
        <!--
         1.您需要填写就诊资料，并付费
2.医生会在48小时内回复您，逾期自动退款
3.医生第一次回复您之后，您可以在48小时内继续追问。
4.各位患者：如果您当前就诊需求三个月内未曾在我院相关科室进行就诊，此为线上咨询服务，内容仅共参考
1.您需要填写就诊资料，并付费
2.医生会在48小时内回复您，逾期自动退款
3.您最多可以回复3条，请尽量将您的问题、希望获得的帮助一次性完整提出
4.各位患者：如果您当前就诊需求三个月内未曾在我院相关科室进行就诊，此为线上咨询服务，内容仅共参考
-->
      </div>
    </div>
    <!--<div @click="goNextStep" class="nextStep center radius10">
      下一步
    </div>-->
    <v-wxts-bottom @next="goNextStep" module="pic"></v-wxts-bottom>
    <router-view></router-view>
    <alert :firstLine="firstLine" :secondLine="secondLine" :bottomLine="bottomLine" @on-iKnow="iKnow()"
           v-if="showAlert"></alert>
  </div>
</template>
<script>
import header from '../../../base/header'
import Alert from '../../../base/alert'
import {avaErrorMixin, isBindMixin, isLoginMixin} from "@/lib/mixin"
import VWxtsBottom from "../../../plugins/v-wxts-bottom";
// import {docService} from "../../../services/doc";
import {OkHttp} from "@/services/base";
import {docTitleMixin} from "@/page/doc/lib";
import {equalTrue} from "@/lib/util";

export default {
  mixins: [isLoginMixin, isBindMixin, avaErrorMixin, docTitleMixin],
  data() {
    return {
      title: "申请须知",
      rightTitle: "",
      firstLine: "您需要先同意《浙二网络医学中心服务协议》",
      secondLine: "",
      bottomLine: "确定",
      showAlert: false,
      path: "",
      doctorId: "",
      doctorInfo: "",
      picked: true,
      price: "",
      query: this.$route.query
    }
  },
  computed: {
    showPrice() {
      const {isOpenFreeClinic, picConsultPrice} = this.query;
      if (equalTrue(isOpenFreeClinic)) {
        return picConsultPrice;
      }
      return this.doctorInfo.docPicConsultPrice;
    },

    limit() {
      const {isOpenFreeClinic, picReplyNum} = this.query;
      const {consultCanReplyNumber} = this.doctorInfo;
      if (equalTrue(isOpenFreeClinic)) return picReplyNum > 0 ? picReplyNum : 0;
      else return consultCanReplyNumber > 0 ? consultCanReplyNumber : 0;
    },


    showLimit() {
      const {isOpenFreeClinic, picReplyNum} = this.query;
      const {consultCanReplyNumber} = this.doctorInfo;
      // 义诊中
      if (equalTrue(isOpenFreeClinic)) {
        if (picReplyNum) return `/${picReplyNum}条`;
        else return '';
      } else {// 常规
        if (consultCanReplyNumber > 0) return `/${consultCanReplyNumber}条`;
        else return '';
      }
    },
    inFreeClinic() {
      return this.query.freeClinicId && equalTrue(this.query.isOpenFreeClinic);
    }
  },
  mounted() {
    this.path = this.$route.path
    this.$nextTick(() => {
//        document.addEventListener('touchmove', function(e){e.preventDefault()}, false);
    })
  },
  created() {
    this.doctorId = this.$route.query.docId;
    if (this.$route.query.consultSource === 'HEALTH_SERVICE') {
      this.goNextStep();
    } else {
      this.getDocInfo();
    }

  },
  methods: {
    async getDocInfo() {
      let {code, obj} = await OkHttp.$http('nethos.doc.card', {
        docId: this.doctorId
      });
      if (code == 0) {
        this.doctorInfo = Object.freeze(obj.sysDoc);
      }
    },

    goPicture() {
      this.$router.push('apply/picture')
    },
    iKnow() {
      this.showAlert = false
    },
    async goNextStep() {
      await this._handlerIsBind(data => {
        if (!data.patIdcard) {
          this.$weuijs.confirm('证件号不能为空，是否去完善信息？', {
            title: "温馨提示",
            buttons: [
              {
                label: "再等等",
                type: "default",
                onClick: () => {
                }
              },
              {
                label: '立即完善',
                type: 'primary',
                onClick: () => {
                  this.$router.replace({
                    path: '/account/perfect',
                    query: {back: this.$route.fullPath}
                  })
                }
              }
            ]
          });
          return false;
        }

        const query = this.$route.query;

        if (this.picked === true) {
          // 来自于报告查询
          if (query.comefrom) {
            return this.$router.replace({
              path: '/report/consult/' + this.doctorId + '/report',
              query: {
                ...query,
                consultType: 'pic'
              }
            })
          }

          this.$router.replace({
            path: '/pictureConsultNext',
            query: {
              docId: this.doctorId,
              price: this.price,
              docType: this.doctorInfo.docType || 'NURSE',
              // 日间手术点击进来的
              dictionaryId: query.dictionaryId,
              missionDeptId: query.missionDeptId,
              surgeryState: query.surgeryState,
              //
              freeClinicId: query.freeClinicId,
              consultSourceId: query.consultSourceId,
              consultSource: query.consultSource,
              compatId: query.compatId,
            }
          })
        } else {
          this.showAlert = true
        }

      }, () => {
        this.$router.replace({
          path: "/bindRelativePhone",
          query: {backPath: this.path}
        });
      })
    },
    back() {
      this.$router.back(-1)
    }
  },
  components: {
    VWxtsBottom,
    "VHeader": header,
    Alert
  },
  watch: {
    "$route": function () {
      this.path = this.$route.path
    }
  }
}
</script>
<style scoped lang="scss">
@import '../../../common/public.scss';

.weui-cells_checkbox .weui-check:checked + .weui-icon-checked:before {
  color: $mainColor;
}

.slide-enter-active, .slide-leave-active {
  transition: all 0.3s;
}

.slide-enter, .slide-leave-to {
  transform: translate3d(100%, 0, 0);
}

.doctorInfo {
  margin-top: 10px;

  ul {
    padding: 0;
    margin: 0 auto;
    width: 690rem/$rem;
    /*<!--height: 204rem/$rem;-->*/
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: rgb(245, 251, 251);

    li {
      list-style-type: none;
      height: 204rem/$rem;
      display: flex;
      position: relative;

      .in_free_clinic {
        font-size: 10px;
        color: #Ff5050;
        right: px2rem(15px);
        top: px2rem(15px);
        position: absolute;
        padding: 0 5px;
        border-radius: 5px;
        border: 1px solid #FF5050;
      }

      .cancelImg {
        width: 180rem/$rem;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 140rem/$rem;
          height: 140rem/$rem;
        }

        /*padding-left: 15px;*/
      }

      .cancelIntro {
        flex: 1 1 auto;
        display: flex;
        align-items: center;
        /*line-height: 10px;*/
        .introTitle {
          .subTitle {
            font-size: 32rem/$rem;
            color: #333333;
          }

          .myDoctor {
            /*<!--width: 120rem/$rem;-->*/
            /*<!--height: 36rem/$rem;-->*/
            display: inline-block;
            font-size: 28rem/$rem;
            /*line-height: 18px;*/
            color: #666666;
            text-align: center;
          }

          p {
            margin: 0;
            font-size: 28rem/$rem;
            color: #999999;
          }
        }

        span {

        }
      }

      img {
        width: 130rem/$rem;

      }

    }
  }
}

.attach {
  width: 690rem/$rem;
  height: 80rem/$rem;
  margin: 2px auto;
  display: flex;
  align-items: center;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: rgb(245, 251, 251);

  > div {
    section {
      width: 690rem/$rem;
      display: flex;
      justify-content: space-between;

      span {
        padding-left: 20rem/$rem;
        padding-right: 20rem/$rem;
        font-size: 32rem/$rem;
        color: #333333;
      }

      span.money {
        color: $assistWordBrown;
      }

      span.time {
        color: $assistWordBlue;
      }
    }
  }
}

.weuiMargin {
  margin: 0;

  p {
    font-size: 28rem/$rem;

    span {
      color: $mainColor;
    }
  }
}

.weui-cells_checkbox .weui-icon-checked:before {
  font-size: 28rem/$rem;
}

.applyRule {
  width: 100%;
  background-color: white;

  .ruleCenter {
    width: 690rem/$rem;
    margin: 0 auto;

    h4 {
      font-size: 32rem/$rem;
      font-weight: normal;
    }
  }
}

.nextStep {
  @extend %a;
}
</style>



// WEBPACK FOOTER //
// src/components/index/onlineDoctor/pictureConsultApply.vue